import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

const ddEnv = (process.env.DD_ENV ?? "").trim();
const version = (process.env.VERSION ?? "").trim();
const shouldInitRum =
  process.env.NODE_ENV === "production" && ["cd", "stage", "production"].includes(ddEnv) && version.length > 0;

if (shouldInitRum) {
  datadogRum.init({
    applicationId: "151db93a-6bc1-4a0d-a162-d8643fd5bfe8",
    clientToken: "pub4fbb5647c72d8b208e392604e175bad4",
    site: "datadoghq.com",
    service: "axio-web",
    env: ddEnv,
    version,
    allowedTracingUrls: [
      (url) => {
        try {
          const u = new URL(url, window.location.origin);
          return u.origin === window.location.origin && u.pathname.startsWith("/api");
        } catch {
          return false;
        }
      },
    ],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    plugins: [reactPlugin({ router: false })],
  });
}
